// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "channels";

Rails.start();
Turbolinks.start();
ActiveStorage.start();

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// Jquery
import jquery from 'jquery';
global.$ = global.jQuery = jquery
window.$ = window.jQuery = jquery;

// Common Lib
import 'bootstrap';
import Chart from 'chart.js/auto'
import moment from 'moment';
import 'chartjs-adapter-moment';
import toastr from 'toastr';

global.toastr = toastr;
// global.bootbox = require('bootbox');
global.Chart = Chart;
global.moment = moment;

import "inputmask";
// require('@ckeditor/ckeditor5-alignment');
// require('select2');
// require('bootstrap-timepicker');

// require('social-share-button');

// Theme + Libraries
import "admin-lte";
// require.context('admin-lte/dist/img', true);
// require("packs/vendor/jquery.editable.min.js");
// require("packs/vendor/flipclock.min.js");
import "packs/vendor/owl.carousel.min.js";
import "packs/vendor/jquery.floatingscroll.min.js";
// require("packs/vendor/bootstrap-datepicker.js");
// require("packs/vendor/jquery.dataTables.min.js");
// require("packs/vendor/ckeditor.js");
require("packs/vendor/smartbanner.min.js");

// AngularJs
import angular from "angular";
global.angular = angular;
import 'angular-sanitize';
import "angular-route";
import "packs/base/init";
import "packs/base/theme";
import "packs/base/ws_chart";
import "packs/base/angular_app";
import "packs/base/angular_utils";

// AngularJs Controllers
global.app = angular.module('app');
window.app = angular.module('app');
import "packs/pages/dashboard_ctrl";
import "packs/pages/listing_ctrl";
import "packs/pages/raffle_ctrl";
import "packs/pages/follower_ctrl";
import "packs/pages/wax_tracker_ctrl";
import "packs/pages/box_ctrl";
// The legacy header overlay, served while the v2 search read switch is off (search_v2_ui?).
import "packs/pages/search_page_ctrl";
import "packs/pages/search_dropdown_ctrl";
import "packs/pages/search_results_ctrl";
import "packs/pages/bread_crumbs_filter";
import "packs/pages/menu_waxstat_ctrl";
import "packs/pages/pyt_ctrl";
import "packs/pages/checklist_ctrl";
import "packs/pages/price_history_ctrl";
import "packs/pages/sitemap_ctrl";
import "packs/pages/search_settings_ctrl";
import "packs/pages/carts_ctrl";
import "packs/pages/store_ctrl";
import "packs/pages/user_ctrl";
import "packs/pages/wax_gpt_ctrl";
import "packs/pages/modals_ctrl";
import "packs/pages/pricing_ctrl";
